import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('json-viewer')
export class JsonViewer extends LitElement {
  static override styles = css`
    :root {
      width: inherit;
      height: inherit;
      font-size: inherit;
    }
  `;

  @property({ type: Boolean, reflect: true, attribute: true })
  inline: boolean = false;

  @property({ type: Number, reflect: true, attribute: true })
  indent: number = 2;

  override attributeChangedCallback(
    name: string,
    old: string | null,
    value: string | null,
  ) {
    super.attributeChangedCallback(name, old, value);
    this.requestUpdate();
  }

  override render() {
    const d = JSON.parse(this.textContent ?? '');
    let str = '';
    if (this.inline) {
      str = JSON.stringify(d);
    } else {
      str = JSON.stringify(d, null, this.indent);
    }
    return html`<pre class="column">${str}</pre>`;
  }
}
